import { useState } from 'react';
import { useSelector } from 'react-redux';
import GridLayoutResizeControls from '../../components/GridLayoutResizeControls';
import PegboardDndCellsContainer from './PegboardDndCellsContainer';
import { getSelectedItemPositionInfo } from '../../redux/selectors/layoutSectionDndSelectors';
import { getSelectedGridLayoutModuleNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import GridDndOverlayContainer from './GridDndOverlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PegboardDndContainer = () => {
  const [containerId, setContainerId] = useState('');
  const [gridLayoutId, setGridLayoutId] = useState('');
  const selectedItemPositionInfo = useSelector(getSelectedItemPositionInfo);
  const selectedGridLayoutModuleNode = useSelector(getSelectedGridLayoutModuleNode);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridDndOverlayContainer, {}), /*#__PURE__*/_jsx(PegboardDndCellsContainer, {
      containerId: containerId,
      gridLayoutId: gridLayoutId
    }), selectedGridLayoutModuleNode && selectedItemPositionInfo && /*#__PURE__*/_jsx(GridLayoutResizeControls, {
      setContainerId: setContainerId,
      setGridLayoutId: setGridLayoutId,
      selectedGridLayoutModuleNode: selectedGridLayoutModuleNode,
      selectedItemPositionInfo: selectedItemPositionInfo
    })]
  });
};
export default PegboardDndContainer;